// eslint-disable-next-line no-restricted-imports
export {
  isDesktop as isDesktopDeviceDetectOnWeb,
  isMobile as isMobileDeviceDetectOnWeb,
  isTablet as isTabletDeviceDetectOnWeb,
  isMacOs as isMacOsDeviceDetectOnWeb,
} from 'react-device-detect'
